import React, { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet-async";
import Loading from "../Loading";
import { BiCheckCircle } from "react-icons/bi";
import { IoCloseCircleOutline } from "react-icons/io5";
import mainLogo from "../assets/logo.svg";
import mobLogo from "../assets/Kancroo-logo.svg";
import HTTP_BASE_URL from "../../constants/HttpConstants";
import Footer from "../Footer";
import { BiLoader } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const Success = () => {

  const navigate = useNavigate();
  const [bookingId, setBookingId] = useState(null);
  const [receiptid, setResceiptId] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [signature, setSignature] = useState(null);
  const [paymentLinkId, setPaymentLinkId] = useState(null);
  const [referenceId, setReferenceId] = useState(null);
  const [linkStatus, setLinkStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);

  function pageLoad() {
    // Extract the 'mobile' parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    setBookingId(urlParams.get("bookingid"));
    setResceiptId(urlParams.get("receiptid"));
    setPaymentId(urlParams.get("razorpay_payment_id"));
    setSignature(urlParams.get("razorpay_signature"));
    setPaymentLinkId(urlParams.get("razorpay_payment_link_id"));
    setReferenceId(urlParams.get("razorpay_payment_link_reference_id"));
    setLinkStatus(urlParams.get("razorpay_payment_link_status"));
  }

  const paymentStatus = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("bookingid", bookingId);
    fullData.append("receiptid", receiptid);
    fullData.append("razorpay_payment_id", paymentId);
    fullData.append("razorpay_signature", signature);
    fullData.append("razorpay_payment_link_id", paymentLinkId);
    fullData.append("razorpay_payment_link_reference_id", referenceId);
    fullData.append("razorpay_payment_link_status", linkStatus);

    try {
      await fetch(HTTP_BASE_URL + "paymentStatus", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            if (result.data.payment_status === "captured") {
              setSuccess(true);
              // console.log(result.data.payment_status)
            }
          } else if (result.code === 1) {
            setFailed(true);
          }
        });
    } catch (error) {
      console.error(error);
    }
  }, [
    bookingId,
    paymentId,
    receiptid,
    signature,
    linkStatus,
    paymentLinkId,
    referenceId,
  ]);

  useEffect(() => {
    pageLoad();
    const timer = setTimeout(() => {
      setIsLoading(false);
      paymentStatus();
    }, 1200);
    return () => clearTimeout(timer);
  }, [paymentStatus]);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Helmet>
            <title>Payment Status</title>
          </Helmet>

          <div>
            <div className="container-fluid bg-white p-0 relative">
              <span className="navbar-brand d-none d-lg-block">
                <img
                  className="logo-image success-logo"
                  src={mainLogo}
                  alt="Represents our brand's identity and commitment to quality."
                  width={166}
                  height={166}
                  loading="eager"
                />
              </span>
              <div className="container mob-header">
                <nav className="navbar p-lg-0">
                  <div className="container-fluid justify-content-center p-0">
                    <div className="navbar-logo d-lg-none">
                      <img
                        className="main-mob-logo img-fluid"
                        src={mobLogo}
                        width={82}
                        height={85}
                        loading="eager"
                        alt="Logo for Kancaroo Trusted Car Carriers, featuring a sleek design with a car silhouette and the company name."
                      />
                    </div>
                  </div>
                </nav>
              </div>
            </div>
            <div className="container-fluid booking-section login-banner">
              <div className="container">
                <div className="loginModel">
                  <div className="loginContent gstModal-content text-center">
                    {!success && !failed && (
                     <>
                     <div>
                     <BiLoader
                     className="rotating-icon"
                          style={{
                            width: "34px",
                            height: "34px"
                          }}
                        />
                     <p className="addGst black pt-2">Please Wait.......</p>
                     </div>
                     </>
                    )}
                    {success && (
                      <div>
                        <BiCheckCircle
                        className="close-icon"
                          style={{
                            width: "34px",
                            height: "34px",
                            color: "#0FA958",
                          }}
                        />
                        
                        <p className="mainHeading green ">
                          Payment Successful!
                        </p>
                        <p className="addGst black pt-2">
                          Thank you! Your payment was completed successfully.
                        </p>
                      </div>
                    )}
                    {failed && (
                      <div>
                        <IoCloseCircleOutline
                        className="close-icon"
                          style={{
                            width: "34px",
                            height: "34px",
                            color: "#D7000C",
                          }}
                        />
                        <p className="mainHeading red "> Payment Failed!</p>
                        <p className="addGst black pt-2">
                          Your payment was unsuccessful. Please try again.
                        </p>
                      </div>
                    )}
                    <button onClick={() => {
                        navigate(`/booking/${bookingId}`);
                      }} className="submit-btn mb-0 mt-3">Go to My Booking</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default Success;
